module.exports = __webpack_public_path__ + "static/2-469e158845689a362c359008a09b8c0e.jpg";